(function() { window.GUID_430b8293_f28c_46b2_a817_26a60c4f20f8 = { getGuid: function() { return "430b8293-f28c-46b2-a817-26a60c4f20f8"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SportEventFees {
            ShowModal(url) {
                Controls.PopupWizard.ShowAjaxModal(url, null, function ({ popup }) {
                    const popupWizard = popup;
                }, function ({ popup }) {
                    const popupWizard = popup;
                });
            }
        }
        Controls.SportEventFees = SportEventFees;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=sportevent-fees.js.map
